import $http from "@/plugins/axios";

/**
 * Get list of cashiers with pending invoices
 * @param {Object} params - Query parameters (page, pageSize, from, to)
 * @returns {Promise} API response
 */
export const getCashiersWithPending = async (params = {}) => {
  const response = await $http.get("invoices/cashiers-with-pending", {
    params,
  });
  return response;
};

/**
 * Get pending invoices for a specific cashier
 * @param {string} cashierId - Cashier ID
 * @param {Object} params - Query parameters (page, pageSize, from, to)
 * @returns {Promise} API response
 */
export const getCashierPending = async (cashierId, params = {}) => {
  const response = await $http.get(`invoices/cashier/${cashierId}/pending`, {
    params,
  });
  return response;
};

/**
 * Bulk approve pending invoices for a cashier
 * @param {string} cashierId - Cashier ID
 * @param {Object} payload - Optional payload (e.g., { note: "Approved by accountant A" })
 * @returns {Promise} API response
 */
export const bulkApproveCashier = async (cashierId, payload = {}) => {
  const response = await $http.post(
    `invoices/cashier/${cashierId}/bulk-approve`,
    payload
  );
  return response;
};

/**
 * Get list of all cashiers with invoice history
 * @param {Object} params - Query parameters (page, pageSize, from, to)
 * @returns {Promise} API response
 */
export const getAllCashiers = async (params = {}) => {
  const response = await $http.get("invoices/all-cashiers", {
    params,
  });
  return response;
};

/**
 * Get all invoices (history) for a specific cashier
 * @param {string} cashierId - Cashier ID
 * @param {Object} params - Query parameters (page, pageSize, from, to, status)
 * @returns {Promise} API response
 */
export const getCashierAll = async (cashierId, params = {}) => {
  const response = await $http.get(`invoices/cashier/${cashierId}/all`, {
    params,
  });
  return response;
};
